<template>
    <div class="page-frame" v-bind:style="maxWidthVal">
        <slot></slot>
    </div>
</template>
<script>
    export default {
        name: 'TrailerFrame',
        props: [ 'maxWidth' ],
        computed : {
            maxWidthVal(){
                const m = this.maxWidth
                return m ? { maxWidth : m } : {}
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import "../scss/vars";

    .page-frame{
        background: white;
        max-width: 900px;
        margin: 0 auto;
        padding: 2rem;
    }
</style>